import { Input } from '@angular/core';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AnimationOptions } from 'ngx-lottie';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'small-button-loader',
  templateUrl: './small-button-loader.component.html',
  styleUrls: ['./small-button-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmallButtonLoaderComponent implements OnInit {
  @Input('width') width: number = 15;
  @Input('height') height: number = 15;
  options: AnimationOptions = {
    path: '/assets/lottie/spinner.json',
  };
  constructor() {}

  ngOnInit() {}
}
